import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

// Split in two to keep hovers cheap; no-op defaults since dashboard tiles have no provider.
const HoveredOptionContext = createContext<string | null>(null);
const SetHoveredOptionContext = createContext<(option: string | null) => void>(
  () => {},
);

interface Props {
  children: ReactNode;
}

export const SplitHighlightProvider = ({ children }: Props) => {
  const [hoveredOption, setHoveredOption] = useState<string | null>(null);

  return (
    <SetHoveredOptionContext.Provider value={setHoveredOption}>
      <HoveredOptionContext.Provider value={hoveredOption}>
        {children}
      </HoveredOptionContext.Provider>
    </SetHoveredOptionContext.Provider>
  );
};

export const useHoveredSplitOption = () => {
  return useContext(HoveredOptionContext);
};

export const useSetHoveredSplitOption = () => {
  return useContext(SetHoveredOptionContext);
};
